import { Typography } from "@mui/material";

import { useAccountReviewCompleteScreen } from "../../shared/AccountReviewUpsell";
import StyledProPage from "../StyledPage";
import { DefaultProOnboardingSteps, ProOnboardingStep } from "../schema";

const completeStepNumber = DefaultProOnboardingSteps.indexOf(
  ProOnboardingStep.complete,
);

interface Props {
  handleNext: () => void;
  handleBack?: () => void;
  onSkip?: () => void;
  nextLoading?: boolean;
}

const ProOnboardingCompleteScreen = ({
  handleNext,
  handleBack,
  onSkip,
  nextLoading,
}: Props) => {
  const reviewProps = useAccountReviewCompleteScreen({
    defaultTitle: "You're Ready 🚀",
    defaultDescription: (
      <Typography sx={{ fontSize: { xs: 13, md: 18 }, my: 3 }}>
        Pro Tip: creators see <strong>3x success rate</strong> when they pitch
        weekly and send 50+ pitches per week
      </Typography>
    ),
    defaultButtonNext: "Start Pitching",
    defaultStepLabel: "Finished",
    stepNumber: completeStepNumber,
    totalSteps: completeStepNumber,
    handleNext,
    onSkip,
  });

  return (
    <StyledProPage
      stepNumber={7}
      {...reviewProps}
      onBack={handleBack}
      buttonBack="Back"
      splitScreen={false}
      loading={nextLoading}
    />
  );
};
export default ProOnboardingCompleteScreen;
